import { Dropdown as AntDropdown, DropdownProps } from "antd";

export type { DropdownProps };

export default function Dropdown(props: DropdownProps) {
  return <AntDropdown {...props} data-test-id="dropdown" />;
}

Dropdown.Button = AntDropdown.Button;
